import { Helmet } from 'react-helmet';

export default function Contact() {
    return (
        <>
            <Helmet>
                <title>Contact | A. Page Code</title>
                <meta name="description" content="Basic example" />
            </Helmet>
            <h1>Contact Us</h1>
        </>
    );
}